export default {"src":"/_next/static/media/login-banner.cf81a162.svg","height":443,"width":238,"blurWidth":0,"blurHeight":0};